import {
    type Notification,
    useFetchNotificationsForUser,
} from "@/queries/useFetchNotificationsForUser.ts";
import { Badge, Tooltip } from "@mui/material";
import { BellRing } from "lucide-react";

type Props = {
    caseUUID: string;
};

const NotificationBadgeForCase = ({ caseUUID }: Props) => {
    const { data: notificationData = [], isLoading } = useFetchNotificationsForUser();

    const foundNotifications = notificationData.filter(
        (notification: Notification) =>
            notification.case.idUUID === caseUUID && notification.hasUnreadNotification,
    ).length;

    if (foundNotifications === 0) {
        return null;
    }

    if (notificationData.length === 0 || isLoading) {
        return null;
    }

    const tooltipText = `${foundNotifications} notification${foundNotifications === 1 ? "" : "s"}`;

    return (
        <Tooltip title={tooltipText} arrow>
            <Badge
                badgeContent={foundNotifications}
                color="error"
                sx={{
                    pl: 1,
                    "& .MuiBadge-badge": {
                        backgroundColor: "red",
                        color: "white",
                    },
                }}
            >
                <BellRing size={20} color="red" />
            </Badge>
        </Tooltip>
    );
};

export default NotificationBadgeForCase;
